// API Configuration
declare const process: {
  env: {
    REACT_APP_API_URL?: string;
    NODE_ENV: string;
  };
};

export const API_CONFIG = {
  // Use environment variable if available, fallback to localhost for development
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:3002',
};

// Helper function to get the full API URL
export const getApiUrl = (): string => {
  return API_CONFIG.BASE_URL;
};

// Helper function for development
export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === 'development';
};

// Helper function for production
export const isProduction = (): boolean => {
  return process.env.NODE_ENV === 'production';
};
